import { CatchAPIService, MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";

class FinanceService {
  DoGetAllBankAccount(isUseMainDatabase = false) {
    const _input: any = {
      merchantId: MerchantId(),
      language: i18n.locale,
      isUseMainDatabase: isUseMainDatabase,
    };
    return service.peakRealTimeAPI
      .post("/api/Finance/GetAllBankAccount", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
}

export default new FinanceService();
